import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import { fetchBlogList } from "@/lib/cmsApi";

function fmtDate(iso) {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-IE", { day: "numeric", month: "long", year: "numeric" }); }
  catch (e) { return iso; }
}

export default function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Insights · AGS Services";
    fetchBlogList().then(setPosts).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#0A0A0A] antialiased">
      <Navigation />
      <main>
        {/* Hero */}
        <section className="bg-[#F4F8FC] pt-40 pb-16 border-b border-[#E5EBF2]">
          <div className="container-ags">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-16 bg-[#2BB6E5]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#0E2A57]">Insights · Journal</span>
            </div>
            <h1 className="font-heading font-extrabold text-5xl md:text-7xl tracking-[-0.04em] text-[#050B14] max-w-4xl">
              Field notes from
              <br />
              <span className="italic-display font-normal text-[#0E2A57]">Ireland's facility floors.</span>
            </h1>
          </div>
        </section>

        <section className="bg-white py-20 md:py-24">
          <div className="container-ags">
            {loading ? (
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#475569]">Loading…</div>
            ) : posts.length === 0 ? (
              <div className="text-center py-16">
                <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#475569]">No posts yet — come back soon.</p>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#0E2A57]/15 border border-[#0E2A57]/15">
                {posts.map((p, i) => (
                  <Link key={p.id} to={`/blog/${p.slug}`} className="group bg-white flex flex-col hover:bg-[#F4F8FC] transition-colors">
                    {p.cover_image_url ? (
                      <div className="aspect-video overflow-hidden">
                        <img src={p.cover_image_url} alt={p.title} className="w-full h-full object-cover img-mono group-hover:scale-[1.04]" />
                      </div>
                    ) : (
                      <div className="aspect-video bg-[#F4F8FC]" />
                    )}
                    <div className="p-6 flex-1 flex flex-col">
                      <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#2BB6E5] flex items-center gap-2">
                        <span>{String(i + 1).padStart(2, "0")}</span>
                        <span className="h-px w-6 bg-[#2BB6E5]/40" />
                        <Calendar size={10} />
                        <span>{fmtDate(p.published_at)}</span>
                      </div>
                      <h2 className="mt-3 font-heading font-bold text-xl text-[#050B14] tracking-[-0.02em] group-hover:text-[#0E2A57] transition-colors">{p.title}</h2>
                      {p.excerpt && <p className="mt-3 text-[#475569] leading-[1.6] line-clamp-3">{p.excerpt}</p>}
                      <span className="mt-5 inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[#0E2A57] group-hover:text-[#2BB6E5]">
                        Read article <ArrowRight size={12} className="transition-transform group-hover:translate-x-1" />
                      </span>
                    </div>
                  </Link>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
